import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import BackToList from '../ui/BackToList'
import AddAssistanceCategoryModal from './AddAssistanceCategoryModal'
import EditAssistanceCategoryModal from './EditAssistanceCategoryModal'
import RemoveAssistanceCategoryModal from './RemoveAssistanceCategoryModal'
import SettingList from './SettingList'

export default class AssistanceCategoryPane extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddAssistanceCategoryModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveAssistanceCategoryModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditAssistanceCategoryModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Assistance Category</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/assistance-category/create'
            >
              <Plus className='svg-white mr1' />
              Add Assistance Category
            </Link>
          </div>
          <hr />
          <div>
            <p className='h5 bold pl2 font-black'>Assistance Category List</p>
            <div className='pl3 pr3 col-4'>
              <SettingList baseUrl={this.props.match.path} settings={[{ label: 'Hearing', id: 1 }]} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AssistanceCategoryPane.tsx